import { useState, useMemo } from 'react';
import { deleteClasses } from '../http/classesApi';
import { useGetClientQuery } from '@/queries/useGetClientQuery';
import { useGetAppointmentsQuery } from '@/queries/useGetAppointmentsQuery';
import { useGetClubsQuery } from '@/queries/useGetClubsQuery';
import { getCookie } from '@/utils/cookies';
import { useQueryClient } from '@tanstack/react-query';

export const useClassesInfo = () => {
  const usertoken: string | null = getCookie('user_token');
  const queryClient = useQueryClient();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [cancelSuccessDialog, setCancelSuccessDialog] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { data: clientData } = useGetClientQuery();
  const { data: appointmentsData = [], refetch: refetchAppointments } = useGetAppointmentsQuery();
  const { data: clubsData } = useGetClubsQuery();
  queryClient.invalidateQueries({ queryKey: ['clubs'] });
  queryClient.invalidateQueries({ queryKey: ['appointments'] });
  const userName = useMemo(() => {
    if (clientData) return `${clientData.name} ${clientData.last_name}`;

    return '';
  }, [clientData]);

  const clubNames = useMemo(() => {
    if (clubsData) {
      return clubsData.reduce((acc, club) => {
        acc[club.id] = club.title;

        return acc;
      }, {});
    }

    return {};
  }, [clubsData]);

  const handleActions = {
    onClickDeleteClasses: (appointmentId: string) => {
      const selectedAppointment = appointmentsData.find(
        (app) => app.appointment_id === appointmentId,
      );
      setSelectedAppointment(appointmentId);
      setSelectedClass(selectedAppointment);
      setDeleteDialog(true);
    },

    handleConfirmDelete: () => {
      deleteClasses(usertoken, selectedAppointment)
        .then((response) => {
          if (response?.status === 200) {
            refetchAppointments();
            setDeleteDialog(false);
            setCancelSuccessDialog(true);
          } else {
            throw new Error('Неожиданный ответ от сервера');
          }
        })
        .catch((error) => {
          console.error('Error deleting appointment:', error);
          let message = 'При отмене занятия произошла ошибка. Обратитесь к администратору.';
          if (error.response?.data?.error_message) {
            message = error.response.data.error_message;
          }
          setErrorMessage(message);
          setErrorDialog(true);
          setDeleteDialog(false);
          setCancelSuccessDialog(false);
        });
    },

    handleCancelSuccessClose: () => {
      refetchAppointments();
      setCancelSuccessDialog(false);
      setSelectedClass(null);
    },

    handleErrorClose: () => {
      setErrorDialog(false);
      refetchAppointments();
    },
  };

  return {
    state: {
      appointments: appointmentsData,
      clubNames,
      deleteDialog,
      cancelSuccessDialog,
      selectedClass,
      userName,
      errorDialog,
      errorMessage,
    },
    actions: {
      setDeleteDialog,
      setErrorDialog,
      ...handleActions,
    },
  };
};
